<template>
  <v-card :min-width="widgetWidth" class="ma-0 pa-0" :loading="loading">
    <v-card-title
      v-if="!loading"
      class="pa-0 ma-0"
      style="max-height: 40px !important"
    >
      <widget-header
        :title="getTitle"
        :color="settingsModel.color ? settingsModel.color : '#607d8b'"
      >
        <template slot="actions">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="mr-2" @click.prevent="refresh"
                >mdi-refresh</v-icon
              >
            </template>
            <span>{{ $t("Refresh") }}</span>
          </v-tooltip>
          <v-tooltip top v-if="enableEdit">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="mr-2" @click.prevent="showSettings"
                >mdi-cog</v-icon
              >
            </template>
            <span>{{ $t("Settings") }}</span>
          </v-tooltip>
          <v-tooltip top v-if="enableEdit">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="mr-2" @click.prevent="removeWidget"
                >mdi-delete</v-icon
              >
            </template>
            <span>{{ $t("Delete") }}</span>
          </v-tooltip>
        </template>
      </widget-header>
    </v-card-title>
    <v-card-text
      class="pa-0 ma-0"
      :style="`height: ${widgetHeight - headerHeight}px;max-height: ${
        widgetHeight - headerHeight
      }px`"
    >
      <base-no-data v-if="!loading && !hasData && widgetHeight > 39" />
      <v-list
        shaped
        v-if="!loading && hasData"
        class="ma-0 pa-0 overflow-y-auto"
        :style="`height: ${widgetHeight - headerHeight}px;max-height: ${
          widgetHeight - headerHeight
        }px`"
      >
        <template v-for="(item, index) in data">
          <div :key="`dashboard-list-item-${item.Id}${widgetId}`">
            <v-divider v-if="index > 0"></v-divider>
            <v-list-item
              v-if="item.Count != 'P'"
              :to="getRoute(item.Id)"
              style="min-height: 35px"
            >
              <v-list-item-content class="ma-0 pa-1">
                <v-list-item-title>{{ item.Description }}</v-list-item-title>
              </v-list-item-content>
              <div v-if="showEndAllDistributionAction(item)">
                <v-tooltip top z-index="1000">
                  <template v-slot:activator="{ on }">
                    <v-list-item-action v-on="on" class="ma-0 pa-0">
                      <v-btn
                        icon
                        @click="endAllDistributions"
                        style="max-height: 40px"
                      >
                        <v-icon>mdi-send-check</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </template>
                  <span>{{ $t("EndAllDistributions") }}</span>
                </v-tooltip>
              </div>
              <v-list-item-icon class="ma-0 pa-1">
                <v-chip v-show="!item.loading">{{ item.Count }}</v-chip>
                <v-chip v-show="item.loading">
                  <v-progress-circular
                    v-show="item.loading"
                    indeterminate
                    color="black"
                    width="1"
                    size="6"
                  ></v-progress-circular
                ></v-chip>
              </v-list-item-icon>
            </v-list-item>
            <v-list-item
              v-if="item.Count == 'P'"
              @click="paramSearch(item.Id)"
              style="min-height: 35px"
            >
              <v-list-item-content class="ma-0 pa-1">
                <v-list-item-title>{{ item.Description }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon class="ma-0 pa-1">
                <v-chip>{{ item.Count }}</v-chip>
              </v-list-item-icon>
            </v-list-item>
          </div>
        </template>
      </v-list>
      <WidgetSettingsModal :ref="modalKey" @on-save="onSettingsSave" />
      <ParamSearchModal :ref="paramSearchModalKey" />
    </v-card-text>
  </v-card>
</template>

<script>
import WidgetSettingsModal from "@/components/widgets/WidgetSettingsModal";
import WidgetSettings from "@/ecm/models/WidgetSettings";
import WidgetService from "@/services/WidgetService";
import WidgetHeader from "@/components/widgets/WidgetHeader";
import WidgetType from "@/ecm/variables/WidgetType";
import SearchType from "@/ecm/variables/SearchType";
import ParamSearchModal from "@/components/search/advSearch/ParamSearchModal.vue";
import DocumentService from "@/services/DocumentService";
import BasketService from "@/services/BasketService";
import SearchService from "@/services/SearchService";
import { mapGetters } from "vuex";

export default {
  components: { WidgetHeader, WidgetSettingsModal, ParamSearchModal },
  name: "WidgetListItem",
  props: {
    widgetId: {
      type: Number,
      default: 0,
    },
    id: {
      type: Number,
      default: 0,
    },
    enableEdit: {
      type: Boolean,
      default: false,
    },
    height: { type: Number, default: 0 },
    width: { type: Number, default: 0 },
    settings: { type: Object },
  },
  mounted() {
    this.widgetHeight = this.height;
    this.widgetWidth = this.width;
    this.settingsModel = new WidgetSettings(this.widgetId, this.settings);
    this.refresh();

    this.connection = $.hubConnection(this.apiUrl);
    this.connection.qs = { access_token: this.token };
    let notificationHub = this.connection.createHubProxy("notificationHub");
    let self = this;

    notificationHub.on("refresh", (notifications) => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(self.refresh, 5000);
    });
    this.connection.start();
  },
  destroyed() {
    if (this.connection) {
      this.connection.stop();
      this.connection = null;
    }
  },
  data() {
    return {
      connection: null,
      title: "",
      color: "",
      loading: false,
      hasData: false,
      data: [],
      headerHeight: 40,
      widgetHeight: 0,
      widgetWidth: 20,
      settingsModel: new WidgetSettings(),
      modalKey: "modalSettingsKey",
      paramSearchModalKey: "paramSearchModalKey",
    };
  },
  methods: {
    setColor() {
      if (this.settingsModel.color == null || "") {
        return "#607d8b";
      } else {
        return this.settingsModel.color;
      }
    },
    resize(height, width) {
      this.widgetHeight = height;
      this.widgetWidth = width;
    },
    showSettings() {
      this.modalSettings.show(
        this.id,
        this.widgetId,
        this.settingsModel.toDto()
      );
    },
    showEndAllDistributionAction(item) {
      return (
        this.widgetId == WidgetType.Distributions &&
        item.Id == 1 &&
        item.Count > 0
      );
    },
    endAllDistributions(e) {
      if (e) {
        e.preventDefault();
      }
      this.$confirm(this.$t("EndAllDistributionsConfirm"), {
        title: this.$t("EndAllDistributions"),
        icon: "mdi-alert",
        color: "warning",
        buttonTrueText: this.$t("Finish"),
        buttonFalseText: this.$t("Cancel"),
      }).then((res) => {
        if (res == 1) {
          DocumentService.endAllDistributions().then((data) => {
            this.refresh();
          });
        }
      });
    },
    onSettingsSave(dto) {
      this.settingsModel = new WidgetSettings(this.widgetId, dto);
      if (
        this.widgetId == WidgetType.Baskets ||
        this.widgetId == WidgetType.UserSearches
      ) {
        this.refresh();
      }
    },
    removeWidget() {
      this.$emit("on-remove-widget", this.id);
    },
    refresh() {
      this.loading = true;
      WidgetService.getData({
        WidgetID: this.widgetId,
        Settings: this.settingsModel.toDto(),
      }).then((data) => {
        if (this.widgetId === WidgetType.Baskets) {
          this.title = this.$t("Baskets");
        }
        if (this.widgetId === WidgetType.UserSearches) {
          this.title = this.$t("SavedSearches");
          if (this.settingsModel.userSearchesToShow.length !== 0) {
            data = data.filter((x) => {
              return this.settingsModel.userSearchesToShow
                  .map((a) => parseInt(a.id))
                  .includes(x.Id);
            });
          }
        }
        if (this.widgetId === WidgetType.Distributions) {
          this.title = this.$t("DistributionInternalExternal");
        }
        this.loading = false;

        if (data.length === 0) {
          this.hasData = false;
          return;
        }
        this.data = data;
        this.hasData = true;
        this.getDasbhoardItemsDocumentCount();
      });
    },
    getDasbhoardItemsDocumentCount() {
      this.data
        .filter((item) => !item.Count)
        .forEach((item) => {
          if (this.widgetId == WidgetType.Baskets) {
            item.loading = true;
            BasketService.getDocumentCount(item).then((count) => {
              item.Count = count;
              item.loading = false;
            });
          }

          if (this.widgetId == WidgetType.UserSearches) {
            item.loading = true;
            SearchService.getUserSearchDocumentCount(item).then((count) => {
              item.Count = count;
              item.loading = false;
            });
          }
        });
    },
    getRoute(id) {
      var route = "search/";

      if (this.widgetId == WidgetType.Baskets) {
        route += `${SearchType.Basket}/${id}`;
      }

      if (this.widgetId == WidgetType.UserSearches) {
        route += `${SearchType.UserSearch}/${id}`;
      }

      if (this.widgetId == WidgetType.Distributions) {
        route += `${SearchType.Distribution}/${id}`;
      }
      return route;
    },
    paramSearch(id) {
      var userSearch = this.$store.getters["account/userSavedSearches"].find(
        (x) => x.Id == id
      );
      if (userSearch.IsParameterizable) {
        this.paramSearchModalInstance.edit(userSearch);
      }
    },
  },
  computed: {
    ...mapGetters({
      user: "account/user",
      apiUrl: "account/apiUrl",
      token: "account/token",
      userContentTypes: "account/userContentTypes",
    }),
    modalSettings() {
      return this.$refs[this.modalKey];
    },
    paramSearchModalInstance() {
      return this.$refs[this.paramSearchModalKey];
    },
    getTitle() {
      if (this.settingsModel.widgetTitle) {
        return this.settingsModel.widgetTitle;
      } else {
        return this.title;
      }
    },
  },
};
</script>
